import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, Calendar } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light text-black mb-6 tracking-tight">
            Professional Journey
          </h2>
          <div className="w-24 h-0.5 bg-black mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A distinguished career spanning public and private sectors, driving digital transformation across Nigeria
          </p>
        </div>

        {/* Experience Timeline */}
        <div className="space-y-8">
          {experience.map((job, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group"
            >
              <CardHeader className="bg-white border-l-4 border-black group-hover:border-gray-600 transition-colors duration-300">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                  <div className="space-y-2">
                    <h3 className="text-2xl font-light text-black">{job.position}</h3>
                    <h4 className="text-xl text-gray-700 font-medium">{job.company}</h4>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 text-gray-600 mt-4 lg:mt-0">
                    <div className="flex items-center space-x-2">
                      <Calendar size={16} />
                      <span className="text-sm">{job.period}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <MapPin size={16} />
                      <span className="text-sm">{job.location}</span>
                    </div>
                  </div>
                </div>
              </CardHeader>
              
              <CardContent className="p-6 space-y-4">
                <p className="text-gray-700 leading-relaxed">{job.description}</p>
                
                {job.achievements && job.achievements.length > 0 && (
                  <div>
                    <h5 className="font-medium text-black mb-3">Key Achievements</h5>
                    <div className="space-y-2">
                      {job.achievements.map((achievement, achIndex) => (
                        <div key={achIndex} className="flex items-start space-x-3">
                          <div className="w-1.5 h-1.5 bg-black rounded-full mt-2 flex-shrink-0"></div>
                          <p className="text-gray-700 text-sm leading-relaxed">{achievement}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Career Highlight Stats */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-sm">
          <h3 className="text-2xl font-light text-black text-center mb-8">Career Highlights</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div className="space-y-2">
              <div className="text-3xl font-light text-black">8</div>
              <div className="text-gray-600 text-sm">Years as NIMC DG/CEO</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-light text-black">1,400%</div>
              <div className="text-gray-600 text-sm">Database Growth</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-light text-black">774</div>
              <div className="text-gray-600 text-sm">LGAs Covered</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-light text-black">3rd</div>
              <div className="text-gray-600 text-sm">Global Ranking (Blockchain ID)</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;